import { render, staticRenderFns } from "./ShippingFast.vue?vue&type=template&id=c195286a&"
import script from "./ShippingFast.vue?vue&type=script&lang=js&"
export * from "./ShippingFast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports